import { render, staticRenderFns } from "./BuyChapterModal.vue?vue&type=template&id=1754dc45&scoped=true&"
import script from "./BuyChapterModal.vue?vue&type=script&lang=js&"
export * from "./BuyChapterModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyChapterModal.vue?vue&type=style&index=0&id=1754dc45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754dc45",
  null
  
)

export default component.exports